import React from 'react'

import ProgressBar from './FulcrumProgressBar'

const FulcrumCircularProgressBar = (props) => (
  <ProgressBar {...props} type='circular'/>
)

export default FulcrumCircularProgressBar
